import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { roles } from "utils/constant";
import Spinner from "utils/Spinner";
import { Button } from "@heroui/react";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

const AttendanceReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const [tableData, setTableData] = useState<any>([]);
  const calendarRef = useRef(null); // Create a ref to access the FullCalendar component

  const [selectedAgent, setSelectedAgent] = useState({ id: undefined, name: "--- Select All ---" });
  const [allAgents, setAllAgents] = useState([]);

  const [startDate, setStartDate] = useState<any>(moment().startOf("day").startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").endOf("month").format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);

  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const [userReport, setUserReport] = useState<any>({});

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);

  const exportToExcel = () => {
    // Prepare event data for Excel
    const data = tableData.map((event) => ({
      Date: moment(event.start).format("DD-MM-YYYY"),
      Time: moment(event.start).format("HH:mm"),
      "Employee Name": event.username,
      "Punch Type": event.entryType,
      Address: event.address,
    }));

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Events");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Attendance Report.xlsx");
  };

  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) =>
      ListCommanWay(
        "/admin/user/list",
        {
          subbranch: qry?.subbranch,
          isActive: true,
          isThirdParty: false,
        },
        { paginate: 100000 },
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([{ id: undefined, name: "--- Select All ---" }, ...data.data.data]);
        }
      },
      onError: (data: any) => {},
    },
  );

  const { mutate: mutateAttendanceFullReport, isLoading: isReportLoading }: any = useMutation(
    (qry: any) =>
      ListCommanWay(
        "/admin/attendence/report",
        {
          createdAt: {
            $gte: moment(startDate).startOf("day"),
            $lte: moment(endDate).endOf("day"),
          },
          user: selectedAgent.id,
        },
        {},
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setUserReport(data?.data?.report[0]);
          const fileUrl = data?.data?.fileUrl;
          if (fileUrl) {
            // Programmatically trigger download
            const link = document.createElement("a");
            link.href = fileUrl;
            link.target = "_blank";
            link.download = fileUrl.split("/").pop(); // Extract filename from URL
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      },
      onError: (data: any) => {},
    },
  );

  const { mutate: mutateAttendanceList, isLoading: isAttendanceLoading }: any = useMutation(
    (qry: any) =>
      ListCommanWay(
        "/admin/attendence/list",
        qry,
        { paginate: 100000, include: ["_user"], order: [["createdAt", "asc"]] },
      ),
    {
      onSuccess(data: any) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          let eventData: any[] = [];
          data.data?.data.forEach((e: any) => {
            eventData.push({
              start: moment(e.createdAt, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              end: moment(e.createdAt, "DD-MM-YYYY HH:mm:ss").add("1", "s").format("YYYY-MM-DD HH:mm:ss"),
              title: e._user.name + " - " + e.type + " - " + moment(e.createdAt, "DD-MM-YYYY HH:mm:ss").format("HH:mm"),
              username: e._user.name,
              entryType: e.type,
              address: e.address,
            });
          });
          setTableData(eventData);

          if (selectedAgent.id) {
            mutateAttendanceFullReport();

            let array = data.data.data;
            const groupedData: any = array.reduce((acc: any, entry: any) => {
              const date = entry.createdAt.split(" ")[0];
              if (!acc[date]) {
                acc[date] = [];
              }
              acc[date].push(entry);
              return acc;
            }, {});

            console.log(groupedData);

            let dateS = moment(startDate).startOf("day");
            let dateE = moment(endDate).startOf("day");
            let totalHolidays = 0;
            let totalDaysInRange = dateE.diff(dateS, "days") + 1;
            for (var m = moment(dateS); m.diff(dateE, "days") <= 0; m.add(1, "days")) {
              if (m.day() == 0) {
                totalHolidays++;
              }
            }

            const hoursWorkedPerDay: any = {};
            let totalHoursInDates = 0;
            let holidayPresent = 0;
            for (const [date, entries] of Object.entries(groupedData) as any) {
              let totalHours = 0;
              let punchInTime: any = null;

              if (moment(date, "DD-MM-YYYY").day() == 0) {
                holidayPresent++;
              }
              entries.forEach((entry: any) => {
                if (entry.type === "IN") {
                  punchInTime = moment(entry.createdAt, "DD-MM-YYYY HH:mm:ss");
                } else if (entry.type === "OUT" && punchInTime) {
                  const punchOutTime = moment(entry.createdAt, "DD-MM-YYYY HH:mm:ss");
                  totalHours += punchOutTime.diff(punchInTime, "hours", true); // Get difference in hours
                  punchInTime = null; // Reset punchInTime
                }
              });

              hoursWorkedPerDay[date] = totalHours;
              totalHoursInDates += totalHours;
            }

            console.log(hoursWorkedPerDay);
          }
        } else {
          setTableData([]);
        }
      },
      onError: (data: any) => {
        setTableData([]);
      },
    },
  );

  const __handleSubmit = async () => {
    mutateAttendanceList({
      createdAt: {
        $gte: moment(startDate).startOf("day"),
        $lte: moment(endDate).endOf("day"),
      },
      user: selectedAgent.id,
    });

    if (calendarRef.current) {
      const calendarApi = (calendarRef.current as any).getApi?.();
      if (calendarApi && startDate) {
        calendarApi.gotoDate(startDate);
      }
    }
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  return (
    <>
      {(loading || isAttendanceLoading || isReportLoading) && <Spinner />}
      <h1 className="text-center mb-3 mt-3 text-lg font-semibold ">Attendance Report</h1>
      <div className="px-4  border-[1px] p-4 mx-4 rounded-md">
        <div className="flex gap-x-4 gap-y-2 items-center">
          <AfDateRangePicker
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            label="Date Range"
          />
          {userDetails.roleName != roles.MIS_CREDIT_CASH ? (
            <div>
              <label className="block mb-0.5 text-sm font-medium text-gray-900 dark:text-white">Select Employee</label>

              <Select
                className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full z-20`}
                options={allAgents}
                onChange={(e: any) => {
                  setSelectedAgent(e);
                }}
                value={selectedAgent}
                getOptionValue={(e) => {
                  return e.id + "";
                }}
                getOptionLabel={(e) => {
                  return e.name;
                }}
              />
            </div>
          ) : (
            ""
          )}
          <button
            type="button"
            onClick={__handleSubmit}
            className=" h-auto rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Submit
          </button>
          <button
            className="h-auto rounded-md px-4 py-2 text-sm font-medium text-white bg-primary border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            onClick={exportToExcel}
          >
            Export to Excel
          </button>{" "}
          <Button onPress={() => mutateAttendanceFullReport()} size="md" color="primary" className="">
            Export Full Report
          </Button>
          {/* Export button */}
        </div>
      </div>

      <div className="flex justify-center mb-5">
        {selectedAgent.id && (
          <table className="border w-auto">
            <thead className="text-sm font-medium font-inter">
              <tr>
                <th className="border px-4">Total Days</th>
                <th className="border px-4">Total Bizz Days</th>
                <th className="border px-4">Total Holidays</th>

                <th className="border px-4">Present Days</th>
                <th className="border px-4">Bizz Present</th>
                <th className="border px-4">Holiday Present</th>

                <th className="border px-4">Total Leave</th>

                <th className="border px-4">Hours</th>
                <th className="border px-4">Bizz Hours</th>
                <th className="border px-4">Holiday Hours</th>

                <th className="border px-4">Avg Daily Hours</th>
                <th className="border px-4">Avg Bizz Hours</th>
                <th className="border px-4">Avg Holiday Hours</th>

                <th className="border px-4">Total Missed Hours</th>
                <th className="border px-4">Total Micro Days</th>
              </tr>
            </thead>
            <tbody className="text-xl font-semibold font-inter text-center">
              <tr>
                <td className="border px-4 py-2 bg-green-200">{userReport?.totalDays}</td>
                <td className="border px-4 py-2 bg-green-200">{userReport?.totalDays - userReport?.totalHoliday}</td>
                <td className="border px-4 py-2 bg-green-200">{userReport?.totalHoliday}</td>
                <td className="border px-4 py-2">{userReport?.attendedDays}</td>
                <td className="border px-4 py-2">{userReport?.attendedBusinessDays}</td>
                <td className="border px-4 py-2">{userReport?.attendedHoliDays}</td>
                <td className="border px-4 py-2">{userReport?.leaveDays}</td>
                <td className="border px-4 py-2">{userReport?.totalHours?.toFixed(2)}</td>
                <td className="border px-4 py-2">{userReport?.totalBusinessHours?.toFixed(2)}</td>
                <td className="border px-4 py-2">{userReport?.totalHolidayHours?.toFixed(2)}</td>
                <td className="border px-4 py-2">
                  {userReport?.attendedDays > 0 ? (userReport?.totalHours / userReport?.attendedDays).toFixed(2) : 0}
                </td>
                <td className="border px-4 py-2">
                  {userReport?.attendedBusinessDays > 0
                    ? (userReport?.totalBusinessHours / userReport?.attendedBusinessDays).toFixed(2)
                    : 0}
                </td>
                <td className="border px-4 py-2">
                  {userReport?.attendedHoliDays > 0 ? (userReport?.totalHolidayHours / userReport?.attendedHoliDays).toFixed(2) : 0}
                </td>
                <td className="border px-4 py-2">{userReport?.totalMissedHours?.toFixed(2)}</td>
                <td className="border px-4 py-2">{userReport?.totalMicroDays}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      <div className="px-4">
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, listPlugin]}
          events={tableData}
          headerToolbar={{
            center: "title",
            start: "dayGridMonth,dayGridWeek,dayGridDay,listMonth",
          }}
          viewWillUnmount={() => {
            setLoading(true);
          }}
          viewDidMount={() => {
            setLoading(false);
          }}
          eventContent={(eventInfo) => {
            const { address } = eventInfo.event.extendedProps; // Access custom keys
            if (eventInfo.view.type == "listMonth") {
              return (
                <p className="px-1 whitespace-normal">
                  <small>
                    {eventInfo.event.title} ::: {address}
                  </small>
                </p>
              );
            } else {
              return (
                <p className="px-1  whitespace-normal border-t">
                  <small>{eventInfo.event.title}</small>
                </p>
              );
            }
          }}
        />
      </div>
    </>
  );
};

export default AttendanceReport;
